module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ranking"
    }
  }, [_c('ul', {
    staticClass: "ranking"
  }, [(_vm.showInvit) ? _c('li', {
    class: {
      active: (_vm.listIndex == 0)
    },
    on: {
      "click": function($event) {
        return _vm.change(0)
      }
    }
  }, [_vm._v("邀请榜")]) : _vm._e(), _vm._v(" "), (_vm.showReward) ? _c('li', {
    class: {
      active: (_vm.listIndex == 1)
    },
    on: {
      "click": function($event) {
        return _vm.change(1)
      }
    }
  }, [_vm._v("打赏榜")]) : _vm._e(), _vm._v(" "), (_vm.showSale) ? _c('li', {
    class: {
      active: (_vm.listIndex == 2)
    },
    on: {
      "click": function($event) {
        return _vm.change(2)
      }
    }
  }, [_vm._v("分销榜")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "lists"
  }, [(_vm.showInvit) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 0),
      expression: "listIndex == 0"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [(_vm.leads.length) ? [_c('van-list', {
    attrs: {
      "finished": _vm.Invitfinished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.loadInvitation
    },
    model: {
      value: (_vm.Invitloading),
      callback: function($$v) {
        _vm.Invitloading = $$v
      },
      expression: "Invitloading"
    }
  }, [_c('ul', {
    staticClass: "leads"
  }, [_vm._l((_vm.leads), function(item, index) {
    return (index < 3) ? _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "headimg"
    }, [(index == 0) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no1_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no2_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no3_top.png'
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "image",
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), (index == 0) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no1_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no2_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no3_bottom.png'
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', [_vm._v("邀请"), _c('span', [_vm._v(" " + _vm._s(item.total) + " ")]), _vm._v("位好友")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "leftimg"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightimg"
  })], 2), _vm._v(" "), _vm._l((_vm.leads), function(item, index) {
    return (index > 2) ? _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [(item.fans_id == _vm.fans_id) ? _c('span', {
      staticClass: "self"
    }, [_vm._v(_vm._s(index + 1))]) : _c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": item.header,
        "alt": item.nick
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("邀请"), _c('span', [_vm._v(" " + _vm._s(item.total) + " ")]), _vm._v("位好友")])]) : _vm._e()
  })], 2)] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showReward) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 1),
      expression: "listIndex == 1"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isRewardLoading),
      callback: function($$v) {
        _vm.isRewardLoading = $$v
      },
      expression: "isRewardLoading"
    }
  }, [(_vm.leadsRe.length) ? [_c('ul', {
    staticClass: "leads"
  }, [_vm._l((_vm.leadsRe), function(item, index) {
    return (index < 3) ? _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "headimg"
    }, [(index == 0) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no1_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no2_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no3_top.png'
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "image",
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), (index == 0) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no1_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no2_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no3_bottom.png'
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', [_vm._v("打赏"), _c('span', [_vm._v(" " + _vm._s(item.top_money / 100) + " ")]), _vm._v("元")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "leftimg"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightimg"
  })], 2), _vm._v(" "), _vm._l((_vm.leadsRe), function(item, index) {
    return (index > 2) ? _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": item.header,
        "alt": item.nick
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("打赏"), _c('span', [_vm._v(" " + _vm._s(item.top_money / 100) + " ")]), _vm._v("元")])]) : _vm._e()
  })] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.showSale) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 2),
      expression: "listIndex == 2"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isSaleLoading),
      callback: function($$v) {
        _vm.isSaleLoading = $$v
      },
      expression: "isSaleLoading"
    }
  }, [(_vm.leadsSa.length) ? [_c('ul', {
    staticClass: "leads"
  }, [_vm._l((_vm.leadsSa), function(item, index) {
    return (index < 3) ? _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "headimg"
    }, [(index == 0) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no1_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no2_top.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-top",
      attrs: {
        "src": _vm.imgPath + 'list/no3_top.png'
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "image",
      attrs: {
        "src": item.header
      }
    }), _vm._v(" "), (index == 0) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no1_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 1) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no2_bottom.png'
      }
    }) : _vm._e(), _vm._v(" "), (index == 2) ? _c('img', {
      staticClass: "image-bottom",
      attrs: {
        "src": _vm.imgPath + 'list/no3_bottom.png'
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "nick"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', [_vm._v("累计获利"), _c('span', [_vm._v(" " + _vm._s(item.total / 100) + " ")]), _vm._v("元")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "leftimg"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightimg"
  })], 2), _vm._v(" "), _vm._l((_vm.leadsSa), function(item, index) {
    return (index > 2) ? _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [_c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": item.header,
        "alt": item.nick
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("累计获利"), _c('span', [_vm._v(" " + _vm._s(item.total / 100) + " ")]), _vm._v("元")])]) : _vm._e()
  })] : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 3),
      expression: "listIndex == 3"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isSchoolLoading),
      callback: function($$v) {
        _vm.isSchoolLoading = $$v
      },
      expression: "isSchoolLoading"
    }
  }, [(_vm.schoolData.length) ? _vm._l((_vm.schoolData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [(index == 0) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/one1.png"
      }
    }) : (index == 1) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/two1.png"
      }
    }) : (index == 2) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/three1.png"
      }
    }) : (index > 2 && index < 5) ? _c('span', {
      staticStyle: {
        "background": "#ff9503"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_vm._v(_vm._s(item.school))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("进来"), _c('span', [_vm._v(" " + _vm._s(item.count) + " ")]), _vm._v("位学生")])])
  }) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listIndex == 4),
      expression: "listIndex == 4"
    }],
    staticClass: "list"
  }, [_c('van-pull-refresh', {
    model: {
      value: (_vm.isClassLoading),
      callback: function($$v) {
        _vm.isClassLoading = $$v
      },
      expression: "isClassLoading"
    }
  }, [(_vm.classData.length) ? _vm._l((_vm.classData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "leadlist"
    }, [_c('div', {
      staticClass: "shu"
    }, [(index == 0) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/one1.png"
      }
    }) : (index == 1) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/two1.png"
      }
    }) : (index == 2) ? _c('img', {
      staticStyle: {
        "width": "25px",
        "margin-top": "6px"
      },
      attrs: {
        "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/zhuzhou/img/three1.png"
      }
    }) : (index > 2 && index < 10) ? _c('span', {
      staticStyle: {
        "background": "#ff9503"
      }
    }, [_vm._v(_vm._s(index + 1))]) : _c('span', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "nick ellipsis",
      staticStyle: {
        "padding-left": "5px"
      }
    }, [_vm._v(_vm._s(item.school + item.grade + item.class))]), _vm._v(" "), _c('p', {
      staticClass: "ellipsis"
    }, [_vm._v("进来"), _c('span', [_vm._v(" " + _vm._s(item.count) + " ")]), _vm._v("位学生")])])
  }) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'nothing.png'
    }
  })])], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5cf5a4e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/menu/List.vue
// module id = 253
// module chunks = 0